const size = {
  sm: {
    fontSize: "10px",
    height: "28px",
    borderRadius: "10px",
  },
  md: {
    fontSize: "14px",
    height: "36px",
    borderRadius: "10px",
  },
  lg: {
    fontSize: "16px",
    height: "40px",
    borderRadius: "15px",
  },
};

export const button = {
  size,
};
